var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import ChartBlock from './chart-block.vue';
import DataTable from './data-table.vue';
import MapBlock from './map-block.vue';
import MermaidBlock from './mermaid-block.vue';
import SiteMapBlock from './site-map-block.vue';
import { artifactUrl } from '../deep-urls';
/**
 * A deep-mode result referenced by id: the answer only carries ```artifact
 * {"artifact_id": "view_1"}```, and the data is fetched from the session's artifact
 * endpoint, so it never passes through the model's output.
 */
var ArtifactBlock = /** @class */ (function (_super) {
    __extends(ArtifactBlock, _super);
    function ArtifactBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.error = null;
        _this.payload = null;
        return _this;
    }
    Object.defineProperty(ArtifactBlock.prototype, "artifactId", {
        get: function () {
            try {
                var parsed = JSON.parse(this.spec);
                return parsed && typeof parsed.artifact_id === 'string' ? parsed.artifact_id : null;
            }
            catch (e) {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArtifactBlock.prototype, "url", {
        get: function () {
            return this.sessionId !== null && this.artifactId
                ? artifactUrl(this.urlTemplate, this.sessionId, this.artifactId)
                : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArtifactBlock.prototype, "isDownload", {
        // export_file results (file_N) are the file itself, not JSON to render.
        get: function () {
            return !!this.url && /^file_\d+$/.test(this.artifactId || '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArtifactBlock.prototype, "chartSpec", {
        get: function () {
            return JSON.stringify((this.payload && this.payload.payload) || {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArtifactBlock.prototype, "diagramSpec", {
        get: function () {
            var inner = this.payload && this.payload.payload;
            return inner && typeof inner.source === 'string' ? inner.source : '';
        },
        enumerable: false,
        configurable: true
    });
    ArtifactBlock.prototype.mounted = function () {
        this.load();
    };
    ArtifactBlock.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isDownload)
                            return [2 /*return*/];
                        if (!this.url) {
                            this.error = this.strings.resultNotFound;
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, fetch(this.url, { credentials: 'same-origin' })];
                    case 2:
                        resp = _b.sent();
                        if (!resp.ok)
                            throw new Error(String(resp.status));
                        _a = this;
                        return [4 /*yield*/, resp.json()];
                    case 3:
                        _a.payload = _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        e_1 = _b.sent();
                        this.error = this.strings.resultNotFound;
                        return [3 /*break*/, 6];
                    case 5:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: String, required: true })
    ], ArtifactBlock.prototype, "spec", void 0);
    __decorate([
        Prop({ type: Number, default: null })
    ], ArtifactBlock.prototype, "sessionId", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], ArtifactBlock.prototype, "urlTemplate", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], ArtifactBlock.prototype, "strings", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({ styleUrl: '', accessToken: '' }); } })
    ], ArtifactBlock.prototype, "mapConfig", void 0);
    ArtifactBlock = __decorate([
        Component({
            components: { ChartBlock: ChartBlock, DataTable: DataTable, MapBlock: MapBlock, MermaidBlock: MermaidBlock, SiteMapBlock: SiteMapBlock },
        })
    ], ArtifactBlock);
    return ArtifactBlock;
}(Vue));
export default ArtifactBlock;
